/**
 * Query keys da plataforma como um todo (não de um clube): as publicações de cada
 * ambiente e as novidades que vieram nelas (docs/funcionalidades/novidades-da-versao.md).
 */
import { tuple } from "./core";

const root = ["plataforma"] as const;

export const plataforma = {
  all: root,
  /** O que o clube vê no CRM (publico = 'clube'), paginado. */
  novidadesDoClube: () => tuple(root, "novidades", "clube"),
  /** Publicações com todas as novidades (admin). */
  publicacoes: () => tuple(root, "publicacoes"),
} as const;
